module.exports = __webpack_public_path__ + "img/shipping-checked.ed19efad.svg";